import { useMutation } from '@tanstack/react-query';

import { adultAllowForMinorRequest } from '@/api/operation';

import { useAppSelector } from '@/hooks/redux';

import { selectLoggedInUser } from '@/redux/auth/selectors';
import { selectUserHolderJointMinor } from '@/redux/user-data/selectors';

type UseMutateMinorConsentProps = {
  onAnswered?: () => void;
};

export const useMutateMinorConsent = ({
  onAnswered,
}: UseMutateMinorConsentProps) => {
  const loggedUser = useAppSelector(selectLoggedInUser);
  const holderJointMinor = useAppSelector(selectUserHolderJointMinor);
  const mutation = useMutation({
    mutationFn: async (payload: {
      allowToDebitCardOnlineBanking: boolean;
      username?: string;
    }) => {
      const operationId = loggedUser?.operationId;
      const clientId = holderJointMinor?.clientId;

      if (!operationId || clientId === undefined) {
        throw new Error('Operation or minor holder not found');
      }

      const updatePayload: Record<string, unknown> = {
        allowToDebitCardOnlineBanking: payload.allowToDebitCardOnlineBanking,
        ...(payload.username && { username: payload.username }),
      };

      return adultAllowForMinorRequest(operationId, clientId, updatePayload);
    },
    onSuccess: () => {
      onAnswered?.();
    },
  });

  return mutation;
};
